// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1U1IR","inner":"Form_inner__2RPsy","range":"Form_range__2ogku","name":"Form_name__2ZpJO","actions":"Form_actions__jGtRN"};